import { assign, MachineConfig } from 'xstate-v4'
import { BookingContext, BookingStateEvent, UserStateSchema } from './types'

export const userMachineConfig: MachineConfig<
  BookingContext,
  UserStateSchema,
  BookingStateEvent
> = {
  type: 'parallel',
  states: {
    data: {
      initial: 'check',
      states: {
        check: {
          onEntry: ['checkUserStore'],
          always: { target: 'checkingEmail', cond: 'notLoggedInAndHasEmail' },
        },
        emailChanged: {
          onEntry: 'setEmail',
          always: [
            {
              target: 'debounceCheckingEmail',
              cond: (e) => !e.firstEmailChange,
            },
            {
              target: 'checkingEmail',
              cond: (e) => !!e.firstEmailChange,
              actions: assign((_) => ({
                firstEmailChange: false,
              })),
            },
          ],
        },
        debounceCheckingEmail: {
          after: {
            500: 'checkingEmail',
          },
        },
        checkingEmail: {
          invoke: {
            src: 'checkEmailService',
            onDone: 'knownEmail',
            onError: 'unknownEmail',
          },
        },
        knownEmail: {},
        unknownEmail: {},
      },
    },
    registerInterest: {
      initial: 'idle',
      on: {
        REGISTER_INTEREST: [
          {
            target: '.registering',
            cond: ({ contactDetails, lastInterestEmail }) =>
              !!contactDetails?.email &&
              contactDetails.email !== lastInterestEmail,
          },
        ],
      },
      states: {
        idle: {},
        registering: {
          invoke: {
            src: 'registerInterest',
            onDone: 'idle',
            onError: 'idle',
          },
          entry: assign({
            lastInterestEmail: ({ contactDetails }) => contactDetails!.email,
          }),
        },
      },
    },
  },
}
